import Hero from "../components/sections/hero";
import Benefits from "../components/sections/benefits";
import Services from "../components/sections/services";
import Stats from "../components/sections/stats";
import Steps from "../components/sections/steps";
import Forms from "../components/sections/forms";
import Testimonials from "../components/sections/testimonials";
import Footer from "../components/sections/footer";
import Header from "../components/layout/header";

export default function Home() {
  return (
    <>
    <Header />
    <main className="pt-16">
      <Hero />
      <Stats />
      <Benefits />
      <Services />
      <Steps />
      <Forms />
      <Testimonials />
      <Footer />
    </main>
    </>
  );
}